// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GSYE","placeholdersHeader":"styles_placeholdersHeader__wymID","editorStyle":"styles_editorStyle__3Ueww","placeholdersBox":"styles_placeholdersBox__2s-MD"};